<template>
  <div id="detail" class="container">
    <div class="detail-body">
      <button @click="$router.go(-1)" class="btn btn-link">Back to Search Results</button>
      <div class="row">
        <div class="" v-bind:class="{'col-md-7': resource.physicalAddress == 1, 'col-md-12': resource.physicalAddress != 1}">
          <h1>{{resource.name}}</h1>
          <div class="resource-description">
            {{resource.description}}
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="address-group">
                <div class="address-subhead detail-subhead">
                  Address
                </div>
                <div v-show="resource.addressNote" class="address-note">{{resource.addressNote}}</div>
                <a
                        v-if="resource.physicalAddress == 1"
                        v-bind:href="'https://maps.google.com/?q=' + encodeURI(resource.address + ', ' + resource.city + ', ' + resource.state + ' ' + resource.zip)"
                        target="_blank"
                >
                  <span class="address-street">{{resource.address}}</span>
                  <br />
                  <span class="address-csz">{{resource.city}}, {{resource.state}} {{resource.zip}}</span>
                </a>
                <div v-if="resource.physicalAddress == 2">
                  <span class="address-street">{{resource.address}}</span>
                  <br />
                  <span class="address-csz">{{resource.city}}, {{resource.state}} {{resource.zip}}</span>
                </div>
              </div>
              <Contacts v-show="contacts.length > 0" v-bind:contacts="contacts"></Contacts>
              <a v-show="resource.website" class="resource-website btn btn-sm btn-secondary no-print" v-bind:href="urlify(resource.website)" target="_blank">Website Link</a>
              <span class="print-only">{{resource.website}}</span>
            </div>
            <div class="col-md-6">
              <Availabilities v-bind:availabilities="availabilities"></Availabilities>
            </div>
          </div>
        </div>
        <div class="col-md-5 no-print">
          <DetailMap v-if="resource.physicalAddress == 1" v-bind:resource="resource"></DetailMap>
        </div>
      </div>
      <div class="row detail-tabs no-print">
        <div class="col-12">
          <b-tabs>
            <b-tab title="Services Info">
              <div class="container">
                <div class="row">
                  <div class="col-md-8">
                    <Categories v-bind:categories="categories" v-bind:category-details="categoryDetails"></Categories>
                  </div>
                  <div class="col-md-4">
                    <Services v-bind:services="services"></Services>
                  </div>
                </div>
              </div>
            </b-tab>
            <b-tab title="Detailed Info">
              <div class="container">
                <div class="row">
                  <div class="col-md-4">
                    <Referral v-bind:referral="referral"></Referral>
                  </div>
                  <div class="col-md-4">
                    <Infos v-bind:infos="infos"></Infos>
                  </div>
                  <div class="col-md-4">
                    <Criteria v-bind:criteria="criteria"></Criteria>
                  </div>
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </div>
      <div class="row print-only">
        <div class="col-md-8">
          <Categories v-bind:categories="categories" v-bind:category-details="categoryDetails"></Categories>
        </div>
        <div class="col-md-4">
          <Services v-bind:services="services"></Services>
        </div>
        <div class="col-md-4">
          <Referral v-bind:referral="referral"></Referral>
        </div>
        <div class="col-md-4">
          <Infos v-bind:infos="infos"></Infos>
        </div>
        <div class="col-md-4">
          <Criteria v-bind:criteria="criteria"></Criteria>
        </div>
      </div>
    </div>
    <div class="detail-footer no-print">
      <ReportProblem v-bind:resource="resource"></ReportProblem>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import Availabilities from '@/components/Availabilities'
  import Contacts from '@/components/Contacts'
  import Referral from '@/components/Referral'
  import Infos from '@/components/Infos'
  import DetailMap from '@/components/DetailMap'
  import Services from '@/components/Services'
  import Categories from '@/components/Categories'
  import Criteria from '@/components/Criteria'
  import ReportProblem from "@/components/ReportProblem";

  export default {
    name: 'detail',
    data (){
      return {
        data: {},
        resource: {
          idResource: -1,
          name: "",
          description: "",
          address: "",
          city: "",
          state: "",
          zip: "",
          website: "",
          lat: 0,
          lng: 0,
          physicalAddress: 1,
          addressNote: null
        },
        availabilities: [{
          idAvailability: -1,
          idResource: -1,
          type: 1,
          sunStart: null,
          sunEnd: null,
          monStart: null,
          monEnd: null,
          tueStart: null,
          tueEnd: null,
          wedStart: null,
          wedEnd: null,
          thuStart: null,
          thuEnd: null,
          friStart: null,
          friEnd: null,
          satStart: null,
          satEnd: null,
          notes: ""
        }],
        contacts: [{
          idContact: -1,
          idResource: -1,
          name: "",
          title: "",
          phone: null,
          email: null,
          note: ""
        }],
        referral: {
          idReferral: -1,
          idResource: -1,
          required: 0,
          selfRefer: 1,
          referEntity: null,
          authRequired: 0,
          priorAuthEntity: null,
          referToEntity: "",
          formLocation: null,
          formURL: null,
          referTurnaround: null,
          notes: ""
        },
        infos: [{
          idResourceInfo: -1,
          idResource: -1,
          idInfo: -1,
          idResourceInfoOption: -1,
          idInfoOption: -1,
          infoTitle: "",
          infoDescription: "",
          note: null,
          optionTitle: "",
          optionDescription: null,
          otherValue: null
        }],
        services: [{
          idResourceService: -1,
          idResource: -1,
          idService: -1,
          note: null,
          title: "",
          description: ""
        }],
        categories: [{
          idResourceCategory: -1,
          idResource: -1,
          idCategory: -1,
          note: null,
          title: "",
          description: ""
        }],
        categoryDetails: [{
          idResourceCategoryDetailOption: -1,
          idResource: -1,
          idCategoryDetailOption: -1,
          idResourceCategory: -1,
          idCategoryDetail: -1,
          idCategory: -1,
          detailTitle: "",
          detailDescription: "",
          optionTitle: "",
          optionDescription: ""
        }],
        criteria: [{
          idResource: -1,
          idCriteria: -1,
          idResourceCriteria: -1,
          idCriteriaOption: -1,
          idResourceCriteriaOption: -1,
          criteriaTitle: "",
          criteriaDescription: "",
          optionTitle: "",
          optionDescription: "",
          note: null
        }]
      }
    },
    components: {
      Availabilities,
      Contacts,
      Referral,
      Infos,
      DetailMap,
      Services,
      Categories,
      Criteria,
      ReportProblem
    },
    methods: {
      urlify(website){
        if(website.toLowerCase().substring(0,4) === "http"){
          return website;
        }
        else {
          return "//" + website;
        }
      }
    },
    mounted (){
      axios.get("/api/resource.php?id=" + this.$route.params.id)
        .then(response => {
          if (response.data){
            this.data = response.data;
            this.resource = response.data.resource;
            this.availabilities = response.data.availabilities;
            this.contacts = response.data.contacts;
            this.referral = response.data.referral;
            this.infos = response.data.infos;
            this.services = response.data.services;
            this.categories = response.data.categories;
            this.categoryDetails = response.data.categoryDetails;
            this.criteria = response.data.criteria;
          }
        })
    },
  }
</script>

<style scoped>

</style>